import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import StopRoundedIcon from "@mui/icons-material/StopRounded";
import { theme } from "../../../components/theme";
import { useParams } from "react-router-dom";
import { useQualityData } from "../../../context/QualityDataContext";

const styles = {
  boxStyle: {
    p: 1,
    height:"90px",
    borderTop: "1px solid #E4E4E4",
  },
  tableStyle: {
    minWidth: 650,
  },
  tableHeadCell: {
    border: "none",
    paddingBottom: 0,
    fontWeight: 600,
    fontSize: "13px",
  },
  tableRow: {
    "&:last-child td, &:last-child th": { border: 0 },
    "& .MuiTableCell-root":{
      padding:"5px 16px"
    }
  },
  tableCell: {
    fontSize: "13px",
  },
};

function CompanyInfoboxTable({ info, dataType, page, productsData }) {
  const { id } = useParams();
  const [selectedProduct, setSelectedProduct] = useState(null);
  useEffect(() => {
    if (page === "By Products") {
      if (id && productsData) {
        const foundProduct = productsData?.find(
          (product) => product.productSystemId == id
        );
        setSelectedProduct(foundProduct);
      }
    }
  }, [id, productsData, page]);
  return (
    <>
      <Box sx={styles.boxStyle}>
        <TableContainer>
          {dataType === "By Parts" ? (
            <Table sx={styles.tableStyle} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell sx={styles.tableHeadCell}>
                    Quality Prediction
                  </TableCell>
                  <TableCell sx={styles.tableHeadCell}>Part ID</TableCell>
                  <TableCell sx={styles.tableHeadCell}>Product ID</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow sx={styles.tableRow}>
                  <TableCell sx={styles.tableCell}>
                    <p style={{ display: "flex", alignItems: "center" }}>
                      <StopRoundedIcon
                        sx={{
                          color:
                            theme.colors[info?.final_status?.toLowerCase()],
                        }}
                      />
                      {info?.final_status}
                    </p>
                  </TableCell>
                  <TableCell sx={styles.tableCell}>{info?.partCode}</TableCell>
                  <TableCell sx={styles.tableCell}>
                    {info?.productCode}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          ) : (
            <Table sx={styles.tableStyle} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell sx={styles.tableHeadCell}>
                    Total Parts Produced
                  </TableCell>
                  <TableCell sx={styles.tableHeadCell}>
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <StopRoundedIcon
                        sx={{ color: theme.colors.scrap, fontSize: "30px" }}
                      />
                      Scrap Parts
                    </span>
                  </TableCell>
                  <TableCell sx={styles.tableHeadCell}>
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <StopRoundedIcon
                        sx={{ color: theme.colors.good, fontSize: "30px" }}
                      />
                      Good Parts
                    </span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow sx={styles.tableRow}>
                  <TableCell sx={styles.tableCell}>
                    {selectedProduct?.total_parts}
                  </TableCell>
                  <TableCell sx={styles.tableCell}>
                    <div style={{ paddingLeft: "10px" }}>
                      {selectedProduct?.scrapped_parts}
                    </div>
                  </TableCell>
                  <TableCell sx={styles.tableCell}>
                    <div style={{ paddingLeft: "10px" }}>
                      {selectedProduct?.good_parts}
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </Box>
    </>
  );
}

export default CompanyInfoboxTable;
